import React from 'react'
import styled, { css, keyframes } from "styled-components";
import LuxWeb3Context from '../../context/LuxWeb3Context';
import theme from '../../utils/theme';


// ENLIGHTEN PIXELS : abrupt on/off blink like the background's dither —
// each square runs its own duration with a negative delay so the grid
// starts mid-pattern and never pulses in unison
const pixelBlink = keyframes`
  0%, 46%  { opacity: 1; }
  50%, 96% { opacity: 0.12; }
  100%     { opacity: 1; }
`;

const pixelTimings = [...Array(20)].map((_, i) => css`
  .pixel:nth-child(${i + 1}) {
    animation-delay: -${((i * 0.73) % 1.9).toFixed(2)}s;
    animation-duration: ${(1.1 + ((i * 0.47) % 1.4)).toFixed(2)}s;
  }
`);


// ~~~~ STYLING
const NavMenuWrapper = styled.div`
    display: inline-flex;
    flex-direction: column;
    align-items: flex-end;
    z-index: 100; // Content panel is at 1000, so 2000 jumps it on top cleanly

// MENU TAP TO CLOSE INVISIBLE DIV
    .menu-tap-to-close {
        position: absolute;
        width: 100vw;
        height: 100vh;
        opacity: 0;
        top: 0;
        left: 0;
        background: #000;
        transition: opacity 0.25s ease-in-out;
        pointer-events: none;
    }


// MENU BACKGROUND
    .menu-background {
        position: absolute;
        width: 153px;
        height: 426px;
        right: -160px;
        top: 0;
        opacity: 0;
        pointer-events: none;
        transition: all 0.25s ease-in-out;
    }
    &.wallet-connected .menu-background {
        height: 456px;
    }


// NAV CONTENT ITEMS
    .nav-content-wrap {
        position: relative;
        top: 15px;
        right: -165px;
        opacity: 0;
        transition: all 0.25s ease-in-out;
        pointer-events: none;

        .menu-option {
            width: 131px;
            font-size: 19px;
            @media (max-width: 767px) { font-size: 17px; }
            line-height: 22px;
            padding: 9px 10px 9px 15px;
            margin-bottom: 15px;
        }
    }


// OPEN ANIMATION STYLE ALIGNMENTS
    &.open {
      z-index: 2000;

      .pane-button.main-button {
          padding: 2px 8px 4px 12px; //Adjust for the X to fit right
      }

      .menu-tap-to-close {
          opacity: 0.35;
          cursor: pointer;
          pointer-events: all;
      }

      .menu-background {
          right: 0;
          opacity: 1;
      }
      .nav-content-wrap {
          right: 0;
          opacity: 1;
          pointer-events: all;
      }
      .pane-button.enlightenment {
          right: 68px; // flush with the menu panel's left edge (156px wide - 46px button) so the open menu reads symmetrical
          opacity: 1;
          pointer-events: all;
      }
    }

    &.enlightenment-on {
        .pane-button.enlightenment {
            right: 10px;
            opacity: 1;
            pointer-events: all;
            z-index: 200;
        }
    }
`;

const TextBox = styled.div`
  /* BUTTON MAIN STYLES */
  &.pane-button {
    cursor: pointer;
    font-size: 28px;
    @media (max-width: 767px) { font-size: 26px; }
    padding: 1px 8px 5px 12px;
    line-height: 30px;
    transition: opacity 0.25s ease-in-out;

    &.main-button {
        max-width: 46px;
        z-index: 100;
        text-overflow: clip;
    }

    &:hover {
      background: #eee !important;
      color: #000 !important;
      text-shadow: 2px 2px 0px rgba(0,0,0,0) !important;
    }
  }


  /* PANE BUTTON : ENLIGHTENMENT — a 5x4 grid of dither pixels blinking
     in the primary cult color, same hue the fluid background runs on */
  &.enlightenment {
    position: absolute;
    top: 10px;
    right: 13px;
    width: 76px;
    height: 38px; /* matches the main =/X button's rendered height */
    z-index: 50;
    opacity: 0;
    transition: all 0.25s ease-in-out;

    .enlighten-pixels {
      position: absolute;
      left: 50%;
      top: 50%;
      transform: translate(-50%, -50%);
      display: grid;
      grid-template-columns: repeat(5, 5px);
      grid-auto-rows: 5px;
      gap: 2px;
      pointer-events: none;

      .pixel {
        background: ${theme.cultPalette[0]};
        animation: ${pixelBlink} 1.6s linear infinite;
      }
      ${pixelTimings}
    }

    &:hover .enlighten-pixels .pixel {
      background: #000;
    }
  }
`;


class NavMenu extends React.Component {
  constructor( props ) {
    super( props );
    this.toggleEnlightenment = this.toggleEnlightenment.bind(this);
    this.clearErrorMsg = this.clearErrorMsg.bind(this);
    this.toggleMenu = this.toggleMenu.bind(this);
    this.navToShop = this.navToShop.bind(this);
    this.navToCart = this.navToCart.bind(this);
    this.navToInfo = this.navToInfo.bind(this);
    this.navToLegal = this.navToLegal.bind(this);
    this.navToContact = this.navToContact.bind(this);
    this.navToMyNeon = this.navToMyNeon.bind(this);
  }
  static contextType = LuxWeb3Context;

  // NAV : Enlightenment Mode Toggler   
  toggleEnlightenment() {
    const { enlightenmentMode, setEnlightenmentMode } = this.context;
    setEnlightenmentMode( !enlightenmentMode );
    this.toggleMenu();
  }

  clearErrorMsg() {
    const { setWalletConnectError } = this.context;
    setWalletConnectError(null);
  }

  // NAV : Open / Close the menu
  toggleMenu() {
    this.context.setMenuOpen( !this.context.isMenuOpen );
  }

  // NAV DESTINATION CONTROLS (Yes slightly lame, but faster / easier)
  navToShop() {
    this.context.setMenuOpen( false );
    this.context.setLocationShop();
  }
  navToCart() {
    this.context.setMenuOpen ( false );
    this.context.setLocationCart();
  }
  navToInfo() {
    this.context.setMenuOpen( false );
    this.context.setLocationInfo();
  }
  navToLegal() {
    this.context.setMenuOpen( false );
    this.context.setLocationLegal();
  }
  navToContact() {
    this.context.setMenuOpen( false );
    this.context.setLocationContact();
  }

  navToMyNeon() {
    this.context.setMenuOpen( false );

    // If no held neon, send to initiate Mode of shop view
    this.context.memberCount < 1 ? (
        this.context.setLocationInitiate()
    ) : (
        this.context.setLocationReliquary()
    );
  }

  logoutUser() {
    window.location.reload();
  }


  render() {
    const { 
      cartProducts,
      connectWallet,
      enlightenmentMode,
      isMenuOpen,
      isWalletConnected, 
    } = this.context;


// ~~~~ NAV BODY
    return (
        <NavMenuWrapper className={ `${isMenuOpen ? 'open':'closed'} ${enlightenmentMode ? 'enlightenment-on': ''} ${isWalletConnected ? 'wallet-connected': ''}` }>

            {/* TAP OUT TO CLOSE FUNCTIONALITY */}
            <div
              onClick={this.toggleMenu}
              onKeyDown={e => { if (e.key === 'Enter' || e.key === ' ') this.toggleMenu(); }}
              className="menu-tap-to-close"
              role="button"
              tabIndex={0}
              aria-label="Close menu"
            ></div>

            {/* BACKGROUND */}
            <div className="menu-background cult-panel cult-button-colors"></div>
            
            {/* BUTTON : MAIN TOGGLE */}
            <TextBox onClick={this.toggleMenu} onKeyDown={e => { if (e.key === 'Enter' || e.key === ' ') this.toggleMenu(); }} role="button" tabIndex={0} aria-label="Toggle menu" className={`pane-button main-button cult-panel`} >{ isMenuOpen ? 'X' : '=' }</TextBox>

            {/* BUTTON : HIDE ALL (Return to Landing) */}
            <TextBox onClick={this.toggleEnlightenment} onKeyDown={e => { if (e.key === 'Enter' || e.key === ' ') this.toggleEnlightenment(); }} role="button" tabIndex={0} aria-label="Toggle enlightenment mode" className="pane-button cult-panel enlightenment">
              <div className="enlighten-pixels" aria-hidden="true">
                {[...Array(20)].map((_, i) => <div className="pixel" key={i} />)}
              </div>
            </TextBox>

            {/* MENU CONTENT */}
            <div className="nav-content-wrap">

                {/* NAV LINKS */}
                <TextBox onClick={this.navToCart} onKeyDown={e => { if (e.key === 'Enter' || e.key === ' ') this.navToCart(); }} role="button" tabIndex={0} className={`pane-button menu-option link-shop cult-panel`}>{`Cart (${cartProducts.length})`}</TextBox>
                <TextBox onClick={this.navToShop} onKeyDown={e => { if (e.key === 'Enter' || e.key === ' ') this.navToShop(); }} role="button" tabIndex={0} className={`pane-button menu-option link-shop cult-panel`}>Shop</TextBox>
                <TextBox onClick={this.navToInfo} onKeyDown={e => { if (e.key === 'Enter' || e.key === ' ') this.navToInfo(); }} role="button" tabIndex={0} className={`pane-button menu-option link-info cult-panel`}>Info</TextBox>
                <TextBox onClick={this.navToLegal} onKeyDown={e => { if (e.key === 'Enter' || e.key === ' ') this.navToLegal(); }} role="button" tabIndex={0} className={`pane-button menu-option link-legal cult-panel`}>Legal</TextBox>
                <TextBox onClick={this.navToContact} onKeyDown={e => { if (e.key === 'Enter' || e.key === ' ') this.navToContact(); }} role="button" tabIndex={0} className={`pane-button menu-option link-contact cult-panel`}>Contact</TextBox>
                
                { /* CONNECT BUTTON */}
                { !isWalletConnected ? (
                    <TextBox onClick={connectWallet} onKeyDown={e => { if (e.key === 'Enter' || e.key === ' ') connectWallet(); }} role="button" tabIndex={0} className={`pane-button menu-option link-connect cult-panel`}>Connect Wallet</TextBox>
                ) : (
                    <TextBox onClick={this.navToMyNeon} onKeyDown={e => { if (e.key === 'Enter' || e.key === ' ') this.navToMyNeon(); }} role="button" tabIndex={0} className={`pane-button menu-option link-reliquary cult-panel`}>My Neon</TextBox>
                )}

                { /* DISCONNECT BUTTON */}
                { isWalletConnected ? (
                    <TextBox onClick={this.logoutUser} onKeyDown={e => { if (e.key === 'Enter' || e.key === ' ') this.logoutUser(); }} role="button" tabIndex={0} className={`pane-button menu-option link-reliquary cult-panel`}>Log Out</TextBox>
                  ):(
                    ''
                )}
            </div>
        </NavMenuWrapper>
    )
  }
};

export default NavMenu;
